import $ from '../lib/jquery';
import { AOS } from '../lib/aos';

import { gsap, ScrollSmoother, ScrollTrigger } from '../lib/gsap';

export function initAllScripts() {
	initAccordion();
	initAjaxRecipesFilters();
	initAjaxBlogFilters();
	initAjaxCompetitionFilters();
	// requestApplication();
	initAjaxOffersFilters();
	initLiveSearch();
	socialResponsibilityTabs();
	initHeaderHeight();
	initScrollSmoother();
}

function initScrollSmoother() {
	// Register GSAP plugins
	// GSAP ScrollSmoother
	// const isMobile =
	// 	/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ||
	// 	window.matchMedia('(hover: none)').matches ||
	// 	window.innerWidth < 768;
	// let smoother = ScrollSmoother.create({
	// 	wrapper: document.querySelector('#smooth-wrapper'), // the element that will be scrolled
	// 	content: document.querySelector('#smooth-content'), // your main content
	// 	smooth: 1.2, // adjust scroll smoothness
	// 	smoothTouch: true, // smooth scrolling on touch devices
	// 	effects: !isMobile, // allows data-speed effects
	// 	// normalizeScroll: true,
	// 	ignoreMobileResize: true,
	// });
	ScrollSmoother.create({
		smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
		effects: true, // looks for data-speed and data-lag attributes on elements
		smoothTouch: false, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	});
}

function initHeaderHeight() {
	function setElementHeightVar(selector, cssVarName) {
		const element = document.querySelector(selector);
		if (!element) return;

		const updateHeight = () => {
			document.documentElement.style.setProperty(cssVarName, element.offsetHeight + 'px');
		};

		updateHeight();
		window.addEventListener('resize', updateHeight);
	}

	setElementHeightVar('.site-header', '--header');
}

function initAccordion() {
	const $accordions = $("[data-component='accordion']");
	if (!$accordions.length) return;

	$accordions.each(function () {
		const $accordion = $(this);
		const $accordionHeader = $accordion.find('[data-accordion-header]');

		$accordionHeader.on('click', function (e) {
			const $item = $(this).closest('[data-accordion-item]');
			const $inner = $item.find('[data-accordion-inner]');

			$accordion
				.find('[data-accordion-item]')
				.not($item)
				.each(function () {
					$(this).attr('aria-expanded', 'false').find('[data-accordion-inner]').slideUp('slow');
				});

			if ($inner.is(':hidden')) {
				$inner.slideDown('slow');
				$item.attr('aria-expanded', 'true');
			} else {
				$inner.slideUp('slow');
				$item.attr('aria-expanded', 'false');
			}
			AOS.refresh();
		});
	});
}

// Recipies AJAX
function initAjaxRecipesFilters() {
	const $recipeArchive = $('#recipes');
	if (!$recipeArchive.length) return;

	const $recipesWrapper = $('.ajax-wrapper');
	const $recipeFilters = $('#recipe-filters');
	const dialog = document.querySelector('dialog#open_dialog-recipe');

	if (!$recipesWrapper.length) return;

	let currentCategory = 'all';
	let currentPage = 1;

	if (dialog) {
		// console.log(dialog);
		document.addEventListener('click', (e) => {
			const btn = e.target.closest('button.open_dialog');
			// console.log(btn);
			if (!btn) return;
			dialog.open ? dialog.close() : dialog.show();
		});
	}
	// Fetch recipes via AJAX
	function fetchRecipes(category, paged) {
		$recipesWrapper.addClass('loading').css('opacity', 0.5);

		$.ajax({
			url: limeAjax.url,
			type: 'POST',
			data: {
				action: 'recipe_filter',
				category: category,
				paged: paged,
			},
			success: function (response) {
				$recipesWrapper.html(response).css('opacity', 1).removeClass('loading');

				currentCategory = category;
				currentPage = paged;

				if (dialog && dialog.open) {
					dialog.close();
				}

				$('html, body').animate(
					{
						scrollTop: $recipesWrapper.offset().top - 300,
					},
					400,
				);

				updateURL(category, paged);
			},
			error: function (xhr, status, error) {
				console.error('AJAX Error:', error);
				$recipesWrapper.css('opacity', 1).removeClass('loading');
				alert('Σφάλμα κατά τη φόρτωση των συνταγών. Παρακαλώ δοκιμάστε ξανά.');
			},
		});
	}

	function updateURL(category, page) {
		const params = new URLSearchParams();

		if (category !== 'all') {
			params.set('category', category);
		}

		if (page > 1) {
			params.set('page', page);
		}

		const newUrl = params.toString()
			? `${window.location.pathname}?${params.toString()}`
			: window.location.pathname;

		history.pushState(null, '', newUrl);
	}

	$recipeFilters.on('submit', function (e) {
		e.preventDefault();

		const category = $('input[name="recipe_category"]:checked').val() || 'all';
		fetchRecipes(category, 1);
	});

	$(document).on('click', '#recipes .pagination a', function (e) {
		e.preventDefault();

		const href = $(this).attr('href');
		const pageMatch = href.match(/[?&]page=(\d+)/);
		const paged = pageMatch ? parseInt(pageMatch[1]) : 1;

		fetchRecipes(currentCategory, paged);
	});

	function initFromURL() {
		const urlParams = new URLSearchParams(window.location.search);
		const urlCategory = urlParams.get('category') || 'all';
		const urlPage = parseInt(urlParams.get('page')) || 1;

		if (urlCategory !== 'all' || urlPage > 1) {
			// Set the radio button
			$(`input[name="recipe_category"][value="${urlCategory}"]`).prop('checked', true);

			currentCategory = urlCategory;
			currentPage = urlPage;
		}
	}

	initFromURL();
}

// BLOG AJAX
function initAjaxBlogFilters() {
	const $blogArchive = $('#blog-archive');
	if (!$blogArchive.length) return;

	const $gridArchive = $blogArchive.find('.grid-archive');
	const $wrapper = $blogArchive.find('.wrapper');

	$blogArchive.on('click', '.pagination a', function (e) {
		e.preventDefault();

		const $link = $(this);
		const href = $link.attr('href');

		const pageMatch = href.match(/[?&]page=(\d+)/);
		const page = pageMatch ? pageMatch[1] : 1;

		loadPosts(page);
	});

	// Load posts via AJAX
	function loadPosts(page) {
		$blogArchive.addClass('loading');

		$.ajax({
			url: limeAjax.url,
			type: 'POST',
			data: {
				action: 'blog',
				paged: page,
			},
			success: function (response) {
				const $response = $(response);

				$gridArchive.html($response.filter('article'));

				const existingPagination = $blogArchive.find('.pagination');
				const newPagination = $response.filter('.pagination');

				if (newPagination.length) {
					if (existingPagination.length) {
						existingPagination.replaceWith(newPagination);
					} else {
						$wrapper.after(newPagination);
					}
				} else {
					existingPagination.remove();
				}

				$blogArchive.removeClass('loading');

				$('html, body').animate(
					{
						scrollTop: $blogArchive.offset().top - 300,
					},
					400,
				);

				const newUrl = `${window.location.pathname}?page=${page}`;
				history.pushState(null, '', newUrl);
			},
			error: function (xhr, status, error) {
				console.error('AJAX Error:', error);
				$blogArchive.removeClass('loading');
				alert('Σφάλμα κατά τη φόρτωση των άρθρων. Παρακαλώ δοκιμάστε ξανά.');
			},
		});
	}
}

// Competition Ajax
function initAjaxCompetitionFilters() {
	const $competitionArchive = $('#competition-archive');
	if (!$competitionArchive.length) return;

	const $gridArchive = $competitionArchive.find('.grid-archive');
	const $wrapper = $competitionArchive.find('.wrapper');

	let currentCategory = new URLSearchParams(window.location.search).get('category') || 'current';
	function loadCompetitions(category, page) {
		$competitionArchive.addClass('loading');

		$.ajax({
			url: limeAjax.url,
			type: 'POST',
			data: {
				action: 'competition',
				category: category,
				paged: page,
			},
			success: function (response) {
				const $response = $(response);
				const $articles = $response.filter('article');

				if ($articles.length) {
					$gridArchive.html($articles);
				} else {
					const $noResults = $response.filter('p');
					$gridArchive.html($noResults.length ? $noResults : '');
				}

				const existingPagination = $competitionArchive.find('.pagination');
				const newPagination = $response.filter('.pagination');

				if (newPagination.length) {
					existingPagination.length
						? existingPagination.replaceWith(newPagination)
						: $wrapper.after(newPagination);
				} else {
					existingPagination.remove();
				}

				$competitionArchive.removeClass('loading');

				// Update URL
				const params = new URLSearchParams();
				if (category) params.set('category', category);
				if (page > 1) params.set('page', page);

				const newUrl = params.toString()
					? `${window.location.pathname}?${params.toString()}`
					: window.location.pathname;

				history.pushState(null, '', newUrl);
			},
			error: function (xhr, status, error) {
				console.error('AJAX Error:', error);
				$competitionArchive.removeClass('loading');
				alert('Σφάλμα κατά τη φόρτωση των διαγωνισμών. Παρακαλώ δοκιμάστε ξανά.');
			},
		});
	}

	// Filter clicks
	$competitionArchive.on('click', '.order-filter', function (e) {
		e.preventDefault();

		const $this = $(this);
		const category = $this.data('category'); // '' for "Όλα"

		$('.order-filter').removeClass('active');
		$this.addClass('active');

		currentCategory = category;
		loadCompetitions(category, 1);
	});

	// Pagination clicks
	$competitionArchive.on('click', '.pagination a', function (e) {
		e.preventDefault();

		const href = $(this).attr('href');
		const pageMatch = href.match(/[?&]page=(\d+)/);
		const page = pageMatch ? parseInt(pageMatch[1]) : 1;

		$('html, body').animate({ scrollTop: $competitionArchive.offset().top - 300 }, 400);

		loadCompetitions(currentCategory, page);
	});
}

// function requestApplication() {
// 	document.querySelectorAll('.request_application').forEach((btn) => {
// 		btn.addEventListener('click', () => {
// 			const appName = btn.dataset.applicationName;
// 			const select = document.querySelector('#your-application');

// 			if (!select) return;

// 			const option = Array.from(select.options).find((opt) => opt.value === appName);

// 			if (option) {
// 				select.value = option.value;

// 				select.dispatchEvent(new Event('change'));

// 				select.scrollIntoView({
// 					behavior: 'smooth',
// 					block: 'center',
// 				});
// 			}
// 		});
// 	});
// }

function socialResponsibilityTabs() {
	const buttons = document.querySelectorAll('.filter-btn');
	const items = document.querySelectorAll('.social_response');

	function filterItems(termId) {
		items.forEach((item) => {
			const terms = item.dataset.terms ? item.dataset.terms.split(' ') : [];

			item.classList.toggle('open-box', terms.includes(termId));
		});
	}

	buttons.forEach((button) => {
		button.addEventListener('click', function () {
			buttons.forEach((btn) => btn.classList.remove('active'));
			this.classList.add('active');

			filterItems(this.dataset.term);
		});
	});

	// Trigger first active button on load
	const firstActive = document.querySelector('.filter-btn.active');

	if (firstActive) {
		filterItems(firstActive.dataset.term);
	}
}

function initLiveSearch() {
	const $input = $('#live-search-input');
	const $results = $('#live-search-results');

	let timeout = null;

	$input.on('keyup', function () {
		const term = $(this).val();

		if (term.length < 3) {
			$results.empty().hide();
			return;
		}

		clearTimeout(timeout);

		timeout = setTimeout(function () {
			$.ajax({
				url: limeAjax.url,
				type: 'POST',
				data: {
					action: 'lime_live_search',
					term: term,
				},
				success: function (response) {
					$results.html(response).show();
				},
			});
		}, 300); // debounce
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.live-search').length) {
			$results.hide();
		}
	});
}

// Offers AJAX
function initAjaxOffersFilters() {
	const $offersWrapper = $('.ajax-wrapper');
	const $offerFilters = $('#offers-filters');
	const dialog = document.querySelector('dialog#open_dialog');

	if (!$offersWrapper.length) return;

	let currentCategory = 'all';
	let currentPage = 1;
	let currentTab = 'all';

	if (dialog) {
		document.addEventListener('click', (e) => {
			const btn = e.target.closest('button.open_dialog');
			if (!btn) return;
			dialog.open ? dialog.close() : dialog.show();
		});
	}
	// Fetch recipes via AJAX
	function fetchOffers(category, tab, paged) {
		$offersWrapper.addClass('loading').css('opacity', 0.5);

		$.ajax({
			url: limeAjax.url,
			type: 'POST',
			data: {
				action: 'offers_filter',
				category: category,
				tab: tab,
				paged: paged,
			},
			success: function (response) {
				$offersWrapper.html(response).css('opacity', 1).removeClass('loading');
				currentTab = tab;
				currentCategory = category;
				currentPage = paged;

				if (dialog && dialog.open) {
					dialog.close();
				}

				$('html, body').animate(
					{
						scrollTop: $offersWrapper.offset().top - 300,
					},
					400,
				);

				updateURL(category, tab, paged);
			},
			error: function (xhr, status, error) {
				console.error('AJAX Error:', error);
				$offersWrapper.css('opacity', 1).removeClass('loading');
				alert('Σφάλμα κατά τη φόρτωση των προσφορών. Παρακαλώ δοκιμάστε ξανά.');
			},
		});
	}

	function updateURL(category, tab, page) {
		const params = new URLSearchParams();

		if (category !== 'all') {
			params.set('category', category);
		}
		if (tab !== 'all') {
			params.set('tab', tab);
		}

		if (page > 1) {
			params.set('page', page);
		}

		const newUrl = params.toString()
			? `${window.location.pathname}?${params.toString()}`
			: window.location.pathname;

		history.pushState(null, '', newUrl);
	}

	$offerFilters.on('submit', function (e) {
		e.preventDefault();

		const category = $('input[name="offer_category"]:checked').val() || 'all';
		fetchOffers(category, currentTab, 1);
	});

	$(document).on('click', '#offer-archive .pagination a', function (e) {
		e.preventDefault();

		const href = $(this).attr('href');
		const pageMatch = href.match(/[?&]page=(\d+)/);
		const paged = pageMatch ? parseInt(pageMatch[1]) : 1;

		fetchOffers(currentCategory, currentTab, paged);
	});

	$(document).on('click', '.article-tabs a', function (e) {
		e.preventDefault();
		$('.article-tabs a').removeClass('active');
		$(this).addClass('active');
		const urlParams = new URLSearchParams(this.getAttribute('href').split('?')[1] || '');
		const tab = urlParams.get('tab') || 'all';
		currentTab = tab;
		fetchOffers(currentCategory, tab, 1);
	});

	function initFromURL() {
		const urlParams = new URLSearchParams(window.location.search);
		const urlCategory = urlParams.get('category') || 'all';
		const urlTab = urlParams.get('tab') || 'all';
		const urlPage = parseInt(urlParams.get('page')) || 1;

		if (urlCategory !== 'all' || urlPage > 1) {
			// Set the radio button
			$(`input[name="offer_category"][value="${urlCategory}"]`).prop('checked', true);

			currentCategory = urlCategory;
			currentPage = urlPage;
			currentTab = urlTab;
		}
	}

	initFromURL();
}
